import React, { useState, useEffect, Fragment, useMemo } from 'react'
import { useHistory } from 'react-router';
import { valdiatePage } from '../../global';
import { getOsansa } from '../../services/reportservice';
import Loader from '../../images/whiteloader.svg';
import { setLoading } from '../../redux/appSlice';
import { useDispatch, useSelector } from 'react-redux';
import ExportExcelButton from "../../components/exportExcelButton";
import Pagination from '../../components/paginations';
import SeeMoreModal from '../../components/SeeMoreModal';
import { getMultipleSubAccountLocations } from '../../services/userservice';

export const qsrColumns = [
  { label: "Consignment Number", key: "ConsignmentNumber" },
  { label: "Account No", key: "AccountNo" },
  { label: "Charges", key: "Charges" },
  { label: "Delivery Date", key: "DeliveryDate" },
  { label: "Area Location", key: "AreaLocation" },
  { label: "Mode Of Delivery", key: "ModeOfDelivery" },
  { label: "Reason", key: "Reason" },
];


const Osansa = () => {

    const dispatch = useDispatch();
    const { accounts, loading, userInfo, subaccounts } = useSelector(state => state.appData);

    const now = new Date();
    const today = `${now.getFullYear()}-${(now.getMonth() + 1).toString().padStart(2, '0')}-${now.getDate().toString().padStart(2, '0')}`;

    const history = useHistory();

    const d = {
        From: today,
        To: today,
        Account: [accounts[0]],
        LocationID: [],
        subAccountId: []
    };
    const [data, setData] = useState(d);
    const [grid, setGrid] = useState([]);
    const [subAccountsLocal, setSubAccountsLocal] = useState([]);
    const [locations, setLocations] = useState([]);

      
    const [page, setPage] = useState(0);
    const [pageLimit, setPageLimit] = useState(50);
    const [sortConfig, setSortConfig] = useState({ key: null, direction: 'ascending' });
    const [originalGrid, setOriginalGrid] = useState([]);
    
    const searchObjInit = {
        ConsignmentNumber: '',
        Charges: '',
        DeliveryDate: '',
        ModeOfDelivery: '',
        Reason: ''
    };


    const [searchObject, setSearchObj] = useState(searchObjInit);
    const updateSearchData = (key, val) => setSearchObj(prev => { return { ...prev, [key]: val } });

    const gridKeys = [
        {key: 'ConsignmentNumber', name: 'Consignment Number', searchBox: true, visible: true},
        {key: 'AccountNo', name: 'Account No', searchBox: false, visible: true},
        {key: 'Charges', name: 'Charges', searchBox: true, visible: true},
        {key: 'DeliveryDate', name: 'Delivery Date', searchBox: true, visible: true},
        {key: 'AreaLocation', name: 'Area Location', searchBox: false, visible: true},
        {key: 'ModeOfDelivery', name: 'Mode Of Delivery', searchBox: true, visible: true},
        {key: 'Reason', name: 'Reason', searchBox: true, visible: true}

    ]
    
    const requestSort = (key) => {
        let direction = 'ascending';
        if (sortConfig.key === key && sortConfig.direction === 'ascending') {
          direction = 'descending';
        }
        setSortConfig({ key, direction });
    };

    let filterData = useMemo(() => {
        return grid.filter((item, index) => {
            return (index >= page * pageLimit) & (index < (page + 1) * pageLimit);
        })
    }, [page, grid, pageLimit, grid.length]);

    const sortedArray = [...filterData].sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) {
          return sortConfig.direction === 'ascending' ? -1 : 1;
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
          return sortConfig.direction === 'ascending' ? 1 : -1;
        }
        return 0;
      });


    // useEffect(() => {
    //     if (!valdiatePage('/consignmentosansa')) {
    //         history.push('/login');
    //     }
    // }, []);

    useEffect(async () => {
        
        if (!valdiatePage('/consignmentosansa')) {
            history.push('/login');
        }

        if (accounts.length > 0) {

            const subAccs = subaccounts.filter(e => e.accountNo.toUpperCase() === accounts[0].toUpperCase())

            setSubAccountsLocal(subAccs);

            const locs = await getMultipleSubAccountLocations({userId: userInfo.id, subAccountId: [subAccs[0].id]})
            const d = { ...data, Account: [accounts[0]], subAccountId: [subAccs[0].id]};

            console.log(locs);
            if (locs.length > 0) {
                d.LocationID = [+locs[0].value] 
                d.creditclientid = [+locs[0].creditClientId] 
                setLocations(locs);
            }
            setData(d);
        }
    }, [])

    const updateData = (key, val) => setData(prev => { return { ...prev, [key]: val } });

    const onSearch = async () => {

        if (!data.From) {
            alert('Select Start Date');
            return;
        }

        if (!data.To) {
            alert('Select End Date');
            return;
        }

        if (data.Account.length == 0) {
            alert('Select Account');
            return;
        }

        dispatch(setLoading({ data: true }));

        var rs = await getOsansa(data);

        dispatch(setLoading({ data: false }));
        if (rs.sts == 0) {
            if (rs.data.length > 0) {
                setGrid(rs.data);
                setOriginalGrid(rs.data);
            }
            else {
                alert('No Data Found');
                setGrid([]);
            }
        }
        else {
            alert(rs.msg);
            setGrid([]);
        }
    }

    return userInfo &&
        <section className="section">
            <div className="section-header">
                <h1>Consignment OSA NSA Report</h1>
            </div>
            <div className="card" style={{ padding: 10 }}>
                <div className="row pb-2">
                    <div className="col">
                        <label>Account</label>
                        <select className="form-select" multiple value={data.Account} onChange={async (e) => {
                            let value = Array.from(e.target.selectedOptions, option => option.value);
                            let d = { ...data, Account: value };
                            if (value && value.length > 0) {
                                const subAccs = subaccounts.filter(e => value.includes(e.accountNo));
                                setSubAccountsLocal(subAccs);
                                const locs = await getMultipleSubAccountLocations({userId: userInfo.id, subAccountId: [subAccs[0].id]})
                                d.subAccountId =  [subAccs[0].id];
                    
                                if (locs.length > 0) {
                                    d.LocationID = [+locs[0].value]
                                    setLocations(locs);
                                } else {
                                    setLocations([]);
                                }
                            } else {
                                setLocations([]);
                            }
                            setData(d);
                        }}>
                            {
                                accounts.map((x, index) => <option key={index} value={x}>{x}</option>)
                            }
                        </select>
                    </div>

                    <div className="col-lg">
                        <label>Sub Account</label>
                        <select className="form-select" value={data.subAccountId} multiple onChange={async (e) => {
                            const selectedOptions = Array.from(e.target.selectedOptions);

                            const accnos = selectedOptions
                                .map(option => option.getAttribute('data-accno'))
                                .filter(acc => acc && acc.trim() !== '');
                    
                            const uniqueAccnos = Array.from(
                                new Map(accnos.map(acc => [acc.toLowerCase(), acc])).values()
                            );

                            const val = Array.from(new Set(
                                selectedOptions
                                    .map(option => option.value)
                                    .filter(v => v && !isNaN(v))
                                    .map(v => parseInt(v))
                            ));


                            console.log("Filtered SubAccount IDs:", val);
                            console.log("Unique Account Nos (data-accno):", uniqueAccnos);

                            const d = { ...data, subAccountId: val, Account: uniqueAccnos };
                            if (val) {
                                //d.isCod = e.target[e.target.selectedIndex].getAttribute('data-iscod') === 'true';
                                const locs = await getMultipleSubAccountLocations({userId: userInfo.id, subAccountId: val})
                                console.log(locs);
                                if (locs && locs.length > 0) {
                                    
                                    d.LocationID = [+locs[0].value]
                                    setLocations(locs);
                                } else {
                                    setLocations([]);
                                }
                            } else {
                                setLocations([]);
                                //d.isCod = null;
                            }
                            setData({ ...d});
                        }}>
                            {
                                subAccountsLocal.map((x, index) => <option key={index} value={x.id} data-iscod={x.isCod} data-accno={x.accountNo}>{x.name}</option>)
                            }
                        </select>
                    </div>

                    <div className="col">
                        <label>Location</label>
                        <select className="form-select" multiple value={data.LocationID} onChange={async (e) => {
                            let val = Array.from(e.target.selectedOptions, option => +option.value);
                            setData({ ...data, LocationID: val });
                        }}>
                            {
                                locations.length > 0 && locations.map((x, index) => <option key={index} data-creditclientid={x.creditClientId} value={x.value}>{x.text}</option>)
                            }
                        </select>
                    </div>
                </div>
                <div className="row pb-2">
                    <div className="col">
                        <label>Start Date</label>
                        <input type="date" className="form-control" value={data.From} onChange={(e) => updateData('From', e.target.value)} />
                    </div>
                    <div className="col">
                        <label>End Date</label>
                        <input type="date" className="form-control" value={data.To} onChange={(e) => updateData('To', e.target.value)} />
                    </div>  
                    <div className="col">
                        <button type="button" className="btn btn-primary" disabled={loading} style={{ marginTop: '1.3rem', display : 'flex', placeSelf: 'self-end' }} onClick={onSearch}>
                            {loading ? <img src={Loader} height="30" /> : 'Search'}
                        </button>
                    </div>
                </div>
                {
                    originalGrid && originalGrid.length > 0 &&
                    <div className="row mt-3 pb-2">
                        <div className="col-12">
                            <div style={{ textAlign: 'right' }}>
                                {/* <ExportExcelQSR data={originalGrid} /> */}
                                   {/* <ExportExcelQSR data={originalGrid} /> */}
                                  <ExportExcelButton data={originalGrid} columns={qsrColumns} fileName="OSANSA_Report"
                                />
                            </div>
                            <br />
                        <Pagination
                            setGrid={setGrid}
                            searchObjInit={searchObjInit}
                            searchObject={searchObject}
                            originalGrid={originalGrid}
                            setPage={setPage}
                            setPageLimit={setPageLimit}
                            requestSort={requestSort}
                            sortConfig={sortConfig}
                            updateSearchData={updateSearchData}
                            sortedArray={sortedArray}
                            data={data}
                            dataCount={grid.length}
                            pageLimit={pageLimit}  
                            gridKeys={gridKeys}
                            page={page}
                            grid={
                                sortedArray && sortedArray.length > 0 && sortedArray.map((x, index) =>
                                    <Fragment key={index}>
                                        <tr key={index}>
                                            <td>{(index + 1)+(page*pageLimit)}</td>
                                            <td>{x.ConsignmentNumber}</td>
                                            <td>{x.AccountNo}</td>
                                            <td>{x.Charges}</td>
                                            <td>{x.DeliveryDate}</td>
                                            <td style={{ minWidth: 200 }}>
                                                <SeeMoreModal detail={x.AreaLocation} maxLength={80} />
                                            </td>
                                            <td>{x.ModeOfDelivery}</td>
                                            <td>{x.Reason}</td>
                                        </tr>
                                    </Fragment>
                                )
                            }
                        />
                        </div>
                    </div>
                }
            </div>
        </section>
}

export default Osansa;